
import tween from '@icons/AnimationPlay.vue'
import automove from '@icons/SwapHorizontal.vue'
import collisionWith from '@icons/ArrowCollapseRight.vue'
import collisionBox from '@icons/ArrowCollapseRight.vue'
import delay from '@icons/Alarm.vue'
import destroy from '@icons/CloseCircle.vue'
import primitive from '@icons/Drawing.vue'
import emitEvent from '@icons/CalendarBlank.vue'
import move from '@icons/CursorMove.vue'
import onEvent from '@icons/CalendarAlert.vue'
import removeComponentFromToy from '@icons/Close.vue'
import repeater from '@icons/Repeat.vue'
import setgamestate from '@icons/HelpCircle.vue'
import sprite from '@icons/Image.vue'
import stopmovement from '@icons/HelpCircle.vue'
import swipecontroller from '@icons/GestureSwipe.vue'
import tapcontroller from '@icons/GestureTap.vue'
import text from '@icons/FormatText.vue'
import sequence from '@icons/FormatListNumbered.vue';
import feature from '@icons/ToyBrick.vue';
import restrictPosition from '@icons/CheckboxIntermediate.vue';
import delayTransform from '@icons/Alarm.vue';
import fetchTransforms from '@icons/Api.vue';
import forEachTransform from '@icons/FormatAlignJustify.vue';
import gridTransform from '@icons/Grid.vue';
import groupTransform from '@icons/SelectGroup.vue';
import randomTransform from '@icons/Dice5.vue';
import randomChoose from '@icons/Dice5.vue';
import onEventTransform from '@icons/RadioTower.vue';
import parallaxTransforms from '@icons/ImageMultiple.vue';
import particleTransform from '@icons/Firework.vue';
import spawner from '@icons/Repeat.vue';
import scrollTransform from '@icons/GestureTap.vue';
import spineTransform from '@icons/Filmstrip.vue';
import stateManager from '@icons/StateMachine.vue';
import draghorizontal from '@icons/PanHorizontal.vue';
import dragvertical from '@icons/PanVertical.vue';
import followpointer from '@icons/Pan.vue';
import unparent from '@icons/LanDisconnect.vue';
import physicsbody2d from '@icons/ChartBellCurve.vue';
import applyforce2d from '@icons/Rocket.vue';
import applyimpulse2d from '@icons/HumanHandsup.vue';
import setlinearvelocity2d from '@icons/AxisArrow.vue';
import cameraFollows from '@icons/Camera.vue';
import video from '@icons/VideoBox.vue';
import playAnimation from '@icons/VideoBox.vue';

export default {
tween,
automove,
collisionWith,
collisionBox,
delay,
destroy,
primitive,
emitEvent,
move,
onEvent,
removeComponentFromToy,
repeater,
setgamestate,
sprite,
stopmovement,
swipecontroller,
tapcontroller,
text,
sequence,
feature,
restrictPosition,
delayTransform,
fetchTransforms,
forEachTransform,
gridTransform,
groupTransform,
randomTransform,
randomChoose,
onEventTransform,
parallaxTransforms,
particleTransform,
spawner,
scrollTransform,
spineTransform,
stateManager,
draghorizontal,
dragvertical,
followpointer,
unparent,
physicsbody2d,
applyforce2d,
applyimpulse2d,
cameraFollows,
setlinearvelocity2d,
video,
playAnimation
}
